import { queryOptions, useQuery } from '@tanstack/react-query'
import { configAjax, MovementScreenConfig } from '../../ajax/ConfigAjax'
import { ErrorResponse } from '../../DTOs/Common/ErrorResponse'

export const movementEntryConfigQuery = queryOptions({
  queryKey: ['config', 'movementEntry'],
  queryFn: async () => {
    const res = await configAjax.getMovementEntryConfig()
    if (ErrorResponse.isErrorResponse(res)) return null
    return res
  },
  staleTime: Infinity,
  gcTime: 1000 * 60 * 60 * 24 * 7,
})

// Note: until the settings arrive, the server's own defaults (MovementEntrySettings). The server applies its
// configured rule whatever layout the client showed, so guessing a laxer layout gets offline rows refused on sync.
const SERVER_DEFAULTS: Record<'rehandle' | 'crushing', MovementScreenConfig> = {
  rehandle: { carriedBy: 'PlantModel', timeEntry: 'None' },
  crushing: { carriedBy: 'DiggerLoader', timeEntry: 'None' },
}

export function useMovementEntryConfig(screen: 'rehandle' | 'crushing'): MovementScreenConfig {
  const { data } = useQuery(movementEntryConfigQuery)

  return data?.[screen] ?? SERVER_DEFAULTS[screen]
}
